<div sbbDialogContent class="EditNoteFilterableLabelsDialogTabContent">
  <ng-container>
    <sbb-note-form [model]="formModel"></sbb-note-form>
  </ng-container>
  <div class="EditNoteFilterableLabelsDialogTabContent">
    <sbb-html-editor [model]="formModel"></sbb-html-editor>
  </div>
</div>
<div sbbDialogActions class="EditNoteDialogTabFooter">
  <button
    class="FunctionButton"
    tabindex="-1"
    mode="icon"
    [title]="'app.view.dialogs.note-dialog.delete-note' | translate"
    (click)="onDeleteNote()"
  >
    <sbb-icon
      svgIcon="trash-medium"
      height="13px"
      width="13px"
      aria-hidden="false"
    ></sbb-icon>
  </button>
</div>
